<template>
  <div id="page" class="booking-validation">
    <booking-show :is-validation="true"
                  :validation-id="$route.params.uid"
                  :is-unlogged="true"
    />
  </div>
</template>

<script>
import BookingShow from '@/views/frontoffice/bookings/show'

export default {
  components: {
    BookingShow
  }
}
</script>
